import * as R from 'ramda';
import { StateType } from 'store/store.types';

export const getCurrentStateFromPath = (path: string, state: StateType) =>
  R.path(path.split('.'), state);
